<script>
import moment from 'moment';
import propertyMap from './../propertyMap';

export default {
  name: 'HistoryListItem',
  props: {
    history: {
      type: Object,
      required: true,
    },
    domain: {
      type: String,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    formattedUpdateDate() {
      return this.history.lastUpdated ? moment(this.history.lastUpdated).format('DD.MM.YYYY') : '';
    },
  },
  methods: {
    mapProperty(code) {
      let mapping = propertyMap.message[code];
      if (!mapping) mapping = code;

      return mapping;
    },
    parseValue(value) {
      let parsedValue = value;

      if (value) {
        if (/\d\d\d\d-\d\d-\d\d \d\d:\d\d:\d\d/.test(value)) {
          parsedValue = moment(this.history.lastUpdated).format('DD.MM.YYYY hh:mm:ss');
        } else if (/\d\d\d\d-\d\d-\d\d/.test(value)) {
          parsedValue = moment(this.history.lastUpdated).format('DD.MM.YYYY');
        }
      } else {
        parsedValue = '';
      }

      return parsedValue;
    },
  },
};
</script>

<template>
  <tr>
    <td>{{ mapProperty(history.className + '.' + history.propertyName) }}</td>
    <td>{{ parseValue(history.oldValue) }}</td>
    <td>{{ parseValue(history.newValue) }}</td>
    <td>{{ history.user }}</td>
    <td>{{ formattedUpdateDate }}</td>
  </tr>
</template>
